import { AuthError, EventError, InteractionRequiredAuthError, PublicClientApplication } from '@azure/msal-browser';

export async function logoutOnAuthError(instance: PublicClientApplication, error: EventError) {
  if (error instanceof AuthError) {
    if (!(error instanceof InteractionRequiredAuthError)) await instance.logoutRedirect();
  }
}
